function openBase64NewTab(base64Pdf: string, isWord?: boolean, isCurrentTab?: boolean): void { //excellent
  if (base64Pdf) {
    var blob = base64toBlob(base64Pdf,isWord);
    const blobUrl = URL.createObjectURL(blob);
    setTimeout(() => {
      isCurrentTab ? window.open(blobUrl, "_top") : window.open(blobUrl);
    }, 0);
  }
}

function base64toBlob(base64Data: string,isWord?: boolean) { //excellent
  const sliceSize = 1024;
  const byteCharacters = atob(base64Data);
  const bytesLength = byteCharacters.length;
  const slicesCount = Math.ceil(bytesLength / sliceSize);
  const byteArrays = new Array(slicesCount);

  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize;
    const end = Math.min(begin + sliceSize, bytesLength);

    const bytes = new Array(end - begin);
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0);
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes);
  }
  return isWord ? new Blob(byteArrays, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"  }) : new Blob(byteArrays, { type: "application/pdf" });
}

export default openBase64NewTab;
